import React, { InputHTMLAttributes } from 'react';

import { DefaultProps, FormatProps } from './types';
import { useField } from './useField';

/**
 * This component accepts
 */
export type TextProps = DefaultProps & FormatProps & InputHTMLAttributes<unknown>;

export const RxText: React.FC<TextProps> = React.memo((props) => {
    const { rest, onInputChange, onInputBlur, ref } = useField(props);
    return <input {...rest} ref={ref as any} name={props.field} onChange={onInputChange} onBlur={onInputBlur} />;
});

export default RxText;

export const Text = RxText;
